import { CreateButton, TopToolbar } from "react-admin";
import { CopyLinksButton } from "./CopyLinksButton";
import { UploadDocumentsConstants as UDC } from "../../../utils/const";

export const Actions = () => (
  <TopToolbar>
    <CreateButton label={UDC.createButtonLabel} />
    <CopyLinksButton />
  </TopToolbar>
);
